import { EmployeeDetails } from '../../../features/employees/EmployeeDetails';
import {
  compose,
  withAuthorized,
  withBaseLayout,
  withHelmet
} from '../../../core';

export const EmployeeDetailsPage = compose(
  withAuthorized,
  withBaseLayout,
  withHelmet({
    title: 'Splashworks: Employees'
  })
)(EmployeeDetails);
